<template>
  <div>
    <AlertDismiss ref="alertDismiss" class="ms-2"></AlertDismiss>
    <div class="card p-2 ps-4 gap-0 fw-medium container-card company-card-container">
      <div class="position-absolute top-0 end-0 d-flex flex-ro p-2 company-header">
        <span class="fw-bold me-1">COMPLIANCE</span>
        <img :src="LoginImg" alt="Login" class="company-logo">
      </div>
      <template v-if="fetching">
        <div class="d-flex align-items-center">
          <b-spinner small class="m-2"></b-spinner>
          <p class="text-secondary m-0">Cargando información de la empresa...</p>
        </div>
      </template>
      <template v-else>
        <h6 class="card-title mb-2">{{ title }}</h6>
        <p class="text-card m-0">
          {{ company.legalName }}
        </p>
        <p class="text-card m-0">
          {{ company.direction }}, {{ company.city }}
        </p>
        <p class="text-card m-0 d-flex justify-content-between align-items-center">
          <span>RUT: {{ formattedRut }}</span>
          <span class="timestamp-text">
            Generado por: <span class="user-name">{{ userName }}</span> el:
            {{ currentDateTime }}
            <b-icon icon="clock" class="me-1"></b-icon>
          </span>
        </p>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AlertDismiss from './Alert-dismiss.vue';
import { formatRut, formatDateTime } from '@/plugins/complianceScripts';
import config from '@/plugins/config';

export default {
  name: 'CompanyInformationCard',

  props: {
    title: {
      type: String,
      required: true
    }
  },
  created() {
    this.fetchUser();
  },

  data() {
    return {
      LoginImg: config.branding.logo,
      company: {
        legalName: '',
        direction: '',
        city: '',
        rut: ''
      },
      userName: '',
      fetching: false
    }
  },

  components: {
    AlertDismiss
  },

  computed: {
    ...mapGetters(["getSession"]),

    formattedRut() {
      return formatRut(this.company.rut);
    },

    currentDateTime() {
      return formatDateTime(new Date());
    }
  },

  methods: {
    ...mapActions(['getCompany', 'getUserById']),
    async fetchUser() {
      const userResponse = await this.getUserById({ id: this.getSession.UserId });
      if (userResponse.isError) {
        this.$refs.alertDismiss.showAlert(userResponse.message);
        this.fetching = false;
        return
      }
      this.userName = userResponse.data.name + ' ' + userResponse.data.lastName
    },
    async fetchCompany() {
      const companyResponse = await this.getCompany();
      if (companyResponse.isError) {
        this.$refs.alertDismiss.showAlert(companyResponse.message, 'danger');
        this.fetching = false;
        return
      }
      this.company = companyResponse.data
    }
  },

  async mounted() {
    this.fetching = true;
    await this.fetchCompany();
    this.fetching = false;
  }
}
</script>

<style scoped>
.card {
  background-color: #ffffff;
  border: 2px solid #000000;
  border-radius: 8px;
}

.text-card {
  color: #000000;
  font-size: 13px;
}

.container-card {
  min-height: 100px;
}

.card-title {
  color: #000000;
  font-weight: 600;
}

.timestamp-text {
  font-size: 12px;
  color: #666666;
}

.company-card-container {
  position: relative;
}

.company-header {
  top: 0;
  right: 0;
  height: 80%;
}

.company-logo {
  height: 30%;
  width: auto;
  object-fit: contain;
  filter: grayscale(100%);
}
.user-name {
  font-weight: bold;
  background-color: #9e9c9c;
  padding: 2px 3px;
  border-radius: 3px;
}
</style>